/**
 * מברשת שמן — מריחות עם "שערות" מרובות, הדגשת אור וצל (מראה שמן קלאסי).
 */

function hexToRgb(hex) {
  const n = String(hex || '').replace('#', '')
  if (n.length !== 6) return [120, 80, 200]
  return [parseInt(n.slice(0, 2), 16), parseInt(n.slice(2, 4), 16), parseInt(n.slice(4, 6), 16)]
}

function rgbToHex(r, g, b) {
  const c = (x) => Math.round(Math.max(0, Math.min(255, x))).toString(16).padStart(2, '0')
  return `#${c(r)}${c(g)}${c(b)}`
}

function mixRgb(a, b, t) {
  return [
    a[0] + (b[0] - a[0]) * t,
    a[1] + (b[1] - a[1]) * t,
    a[2] + (b[2] - a[2]) * t,
  ]
}

function hash2(x, y) {
  const s = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453
  return s - Math.floor(s)
}

function strokePoints(prev, x, y, step) {
  const dx = x - prev.x
  const dy = y - prev.y
  const dist = Math.hypot(dx, dy)
  if (dist < 0.5) return [{ x, y, t: 1, angle: 0 }]
  const n = Math.max(1, Math.ceil(dist / step))
  const angle = Math.atan2(dy, dx)
  const pts = []
  for (let i = 0; i <= n; i++) {
    const t = i / n
    pts.push({ x: prev.x + dx * t, y: prev.y + dy * t, t, angle })
  }
  return pts
}

function paintBristle(ctx, x1, y1, x2, y2, color, width, alpha) {
  ctx.save()
  ctx.globalAlpha = alpha
  ctx.strokeStyle = color
  ctx.lineWidth = width
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'
  ctx.beginPath()
  ctx.moveTo(x1, y1)
  ctx.lineTo(x2, y2)
  ctx.stroke()
  ctx.restore()
}

function paintOilDab(ctx, cx, cy, baseRgb, brushSize, intensity, angle) {
  const t = Math.max(0.4, Math.min(1.2, intensity))
  const bristles = Math.max(6, Math.round(brushSize * 0.42 * t))
  const perp = angle + Math.PI / 2
  const spread = brushSize * 0.38 * t
  const bodyHex = rgbToHex(...baseRgb)
  const shadowHex = rgbToHex(...mixRgb(baseRgb, [0, 0, 0], 0.32))
  const hiHex = rgbToHex(...mixRgb(baseRgb, [255, 255, 255], 0.38))

  ctx.save()
  ctx.globalCompositeOperation = 'multiply'

  for (let i = 0; i < bristles; i++) {
    const h = hash2(cx + i * 3.1, cy + i * 7.7)
    const off = (i / (bristles - 1 || 1) - 0.5) * spread * (0.85 + (h - 0.5) * 0.35)
    const ox = Math.cos(perp) * off
    const oy = Math.sin(perp) * off
    const len = brushSize * (0.22 + h * 0.18) * t
    const dx = Math.cos(angle) * len
    const dy = Math.sin(angle) * len
    const w = Math.max(0.8, brushSize * (0.045 + h * 0.035))
    paintBristle(ctx, cx + ox - dx * 0.5, cy + oy - dy * 0.5, cx + ox + dx * 0.5, cy + oy + dy * 0.5, shadowHex, w * 1.15, 0.22)
    paintBristle(ctx, cx + ox - dx * 0.5, cy + oy - dy * 0.5, cx + ox + dx * 0.5, cy + oy + dy * 0.5, bodyHex, w, 0.52)
  }

  const hx = cx + Math.cos(angle + 0.4) * brushSize * 0.12
  const hy = cy + Math.sin(angle + 0.4) * brushSize * 0.12
  ctx.globalCompositeOperation = 'source-over'
  ctx.globalAlpha = 0.38 * t
  ctx.fillStyle = hiHex
  ctx.beginPath()
  ctx.ellipse(hx, hy, brushSize * 0.14, brushSize * 0.1, angle, 0, Math.PI * 2)
  ctx.fill()

  ctx.restore()
}

/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} x
 * @param {number} y
 * @param {{ x: number, y: number } | null} prev
 * @param {{ color: string, brushSize: number, intensity?: number }} opts
 */
export function drawOilBrushStroke(ctx, x, y, prev, opts) {
  const { color, brushSize, intensity = 1 } = opts
  const baseRgb = hexToRgb(color)
  const size = Math.max(6, brushSize)

  if (!prev) {
    paintOilDab(ctx, x, y, baseRgb, size, intensity, hash2(x, y) * Math.PI * 2)
    return
  }

  const step = Math.max(2.5, size * 0.16)
  const points = strokePoints(prev, x, y, step)

  for (const pt of points) {
    const wobble = size * 0.08 * (hash2(pt.x, pt.y) - 0.5)
    paintOilDab(ctx, pt.x + wobble, pt.y + wobble, baseRgb, size, intensity, pt.angle)
  }
}
